import { useEffect, useState } from 'react'
import { useTheme, useTextTheme } from '../../theme/hooks'

type CodeTimerProps = {
  duration: number
  onExpire?: () => void
}

export default function CodeTimer({ duration, onExpire }: CodeTimerProps) {
  const { theme } = useTheme()
  const textTheme = useTextTheme()
  const [timeLeft, setTimeLeft] = useState<number>(duration)

  useEffect(() => {
    if (timeLeft <= 0) {
      onExpire?.()
      return
    }

    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(timer)
          onExpire?.()
          return 0
        }
        return prev - 1
      })
    }, 1000)

    return () => clearInterval(timer)
  }, [timeLeft, onExpire])

  const minutes = Math.floor(timeLeft / 60)
  const seconds = timeLeft % 60
  const progress = (timeLeft / duration) * 100

  return (
    <div className="flex flex-col items-center justify-center space-y-2">
      <div className="relative h-16 w-16">
        <svg className="h-16 w-16 -rotate-90 transform">
          <circle
            cx="32"
            cy="32"
            r="28"
            stroke={theme.border.primary}
            strokeWidth="4"
            fill="none"
          />
          <circle
            cx="32"
            cy="32"
            r="28"
            stroke={theme.status.success.icon}
            strokeWidth="4"
            fill="none"
            strokeDasharray={`${2 * Math.PI * 28}`}
            strokeDashoffset={`${2 * Math.PI * 28 * (1 - progress / 100)}`}
            className="transition-all duration-1000 ease-linear"
            strokeLinecap="round"
          />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-sm font-bold" style={{ color: textTheme.secondary }}>
            {String(minutes).padStart(2, '0')}:
            {String(seconds).padStart(2, '0')}
          </span>
        </div>
      </div>
      <p className="text-xs" style={{ color: textTheme.tertiary }}>
        {timeLeft > 0 ? 'Code valide pendant' : 'Code expiré'}
      </p>
    </div>
  )
}
